// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nstration[data-v-81790f6e]{display:block;color:#999;font-size:12px;margin-bottom:10px}.configInput[data-v-81790f6e]{position:relative;font-size:14px;display:inline-block;width:80px;margin:0 5px}", ""]);
// Exports
module.exports = exports;
